var _style, _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefinitiv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 244 172",
    style: {
      enableBackground: "new 0 0 244 172"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0020FE;}\r\n\t.st1{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.5,104.5h-5.9L187.1,84h23.5v4.1H197L213.5,104.5z M210.5,67.5h-37v37h4.1V71.6h32.9V67.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6,95.1h3.6l-4-8.2h0.1c2.1-0.6,3.5-2.5,3.3-4.6c0-3.4-2.1-5.4-5.8-5.4h-7.3v18.2h3.3v-7.6h3.2L40.6,95.1L40.6,95.1z  M33.8,85v-5.5h3.4c2,0,3.1,0.9,3.1,2.7c0,1.9-1.1,2.7-3.7,2.7L33.8,85z M57.7,87v-2.8h-6.3v-4.6H60v-2.7H48v18.2h12.3v-2.7h-9V87 H57.7z M74.3,84.3h-6.2v-4.6h8.2v-2.7H64.8v18.2h3.3V87h6.2V84.3L74.3,84.3z M80.3,76.9v18.2h3.3V76.9L80.3,76.9z M108.8,76.9v18.2 h3.3V76.9L108.8,76.9z M129.1,76.9h-13v2.7h4.9v15.5h3.3V79.6h4.8L129.1,76.9L129.1,76.9z M133.1,76.9v18.2h3.3V76.9L133.1,76.9z  M100.2,76.9v12.9h-0.1l-7.4-12.9h-3.5v18.2h3.1V81.6l0,0l4.1,7.1l3.7,6.4h3.2V76.9L100.2,76.9z M152,76.9l-4.2,14.8l0,0l-4.3-14.8 h-3.2l5.6,18.2h3.8l5.6-18.2H152z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 63,
    className: "st1",
    width: 196,
    height: 46
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefinitiv);
export default __webpack_public_path__ + "static/media/refinitiv.949c49f61fac14be7ac37c99687d9956.svg";
export { ForwardRef as ReactComponent };